import { createContext, type PropsWithChildren, useContext, useState } from 'react';

type PartnerNetworkOverviewContextType = {
    showPartnerNetworkOverview: boolean;
    setShowPartnerNetworkOverview: (show: boolean) => void;
    showOnboarding: boolean;
    setShowOnboarding: (show: boolean) => void;
    showCreateDialog: boolean;
    setShowCreateDialog: (show: boolean) => void;
};

export const PartnerNetworkOverviewContext = createContext<PartnerNetworkOverviewContextType>(
    {} as unknown as PartnerNetworkOverviewContextType
);
export const usePartnerNetworkOverviewContext = () => useContext(PartnerNetworkOverviewContext);

const PartnerNetworkOverviewContextProvider = ({ children }: PropsWithChildren) => {
    const [showPartnerNetworkOverview, setShowPartnerNetworkOverview] = useState(false);
    const [showOnboarding, setShowOnboarding] = useState(false);
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    return (
        <PartnerNetworkOverviewContext.Provider
            value={{
                setShowPartnerNetworkOverview,
                showPartnerNetworkOverview,
                showOnboarding,
                setShowOnboarding,
                setShowCreateDialog,
                showCreateDialog,
            }}
        >
            {children}
        </PartnerNetworkOverviewContext.Provider>
    );
};

export default PartnerNetworkOverviewContextProvider;
